<template>
  <div class="section-main__warp car-mg_person_research car-track-search">
    <div style="position: relative; height: 100%; width: 100%">
      <div :class="'vehicle-to ' + (visibleRight ? 'expand' : 'collspand')">
        <div class="blur-bg map-blur-panel"></div>
        <template v-if="main">
          <div class="section-content" id="main">
            <div class="search-title">条件检索</div>
            <el-scrollbar class="search-content flex-auto no-scroll-x">
              <div class="search-bg" style="height: 100%">
                <div class="search-form">
                  <el-form ref="ruleForm" :model="formData" :rules="rules" label-width="95px" label-position="right">
                    <el-form-item label="车牌号" prop="carNumber" label-width="80px">
                      <el-input v-model="formData.carNumber" placeholder="请输入车牌号"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="startTime" label-width="80px">
                      <el-date-picker style="width: 100%" @change="timeChange" v-model="formData.startTime"
                        type="datetime" placeholder="请选择开始时间">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="endTime" label-width="80px">
                      <el-date-picker v-model="formData.endTime" type="datetime" style="width: 100%" placeholder="请选择结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-scrollbar>
            <el-row type="flex" justify="center" style="padding: 16px 0">
              <el-button size="mini" type="primary" :loading="searchBtn" @click="submitClick('ruleForm')">{{ searchBtn ?
                "查询中" : "查询" }}</el-button>
              <el-button size="mini" :loading="searchBtn" type="info" @click="resetFrom">{{ searchBtn ? "查询中" : "重置"
              }}</el-button>
            </el-row>
          </div>
        </template>
        <template v-else>
          <div style="height: 100%; position: relative" class="flex-valign" id="peopleInfo">
            <div class="title">轨迹信息</div>
            <el-scrollbar class="search-content flex-auto no-scroll-x">
              <div class="flex-auto" style="overflow: auto" v-if="personDataList && personDataList.length">
                <div v-for="(item, index) in personDataList" :key="index"
                  :class="['track-box', index == selectedFlag ? 'selected-track-box' : '']" @click="getTrajectory(item.records, index)">
                  轨迹日期：{{ item.date }}
                </div>
              </div>
            </el-scrollbar>
            <el-row type="flex" justify="center" style="padding: 16px 0">
              <el-button size="mini" type="info" @click="back">关闭</el-button>
            </el-row>
          </div>
        </template>
        <div :class="'map-blur-panel__expand-button right ' +
          (visibleRight ? 'expand' : 'collspand')
          " @click="handleVisible">
          <i class="el-icon-s-fold" v-if="!visibleRight"></i>
          <i class="el-icon-s-unfold" v-if="visibleRight"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bus, Dates, Cache } from "$utils";
import { api } from "../api";
export default {
  data() {
    return {
      searchBtn: false,
      imageUrl: "",
      fileId: "",
      formData: {
        startTime: Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7),
        endTime: Dates.parse(Dates.format(new Date())),
        carNumber: ""
      },
      rules: {
        endTime: [{ required: true, message: "选择结束时间" }],
        startTime: [{ required: true, message: "选择开始时间" }],
        carNumber: [{ required: true, message: "请输入车牌号" }],
      },
      // rules: {},
      visibleRight: true,
      main: true,
      lineLayerID: "trackLayer",
      circlesLayerID: "circlesLayer",
      constLayerId: {
        circles: "alarm-circles",
        line: "alarm-line",
      },
      trackPoints: [],
      personDataList: [],
      selectedFlag: 0
    };
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    // this.clearTrack();
  },
  methods: {
    getDate(time) {
      let year = new Date(time).getFullYear();
      let month = new Date(time).getMonth() + 1;
      let day = new Date(time).getDate();
      let hour = new Date(time).getHours();
      let minutes = new Date(time).getMinutes();
      let second = new Date(time).getSeconds();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return (year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + second);
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    clearTrack() {
      this.$map.MapInstance2D.clear();
    },
    onRemoveFile(file) {
      this.imageUrl = "";
      this.fileId = ""
    },
    //开始时间----结束时间相隔7天
    timeChange(data) {
      this.formData.endTime = Dates.format(
        data.getTime() + 24 * 60 * 60 * 1000 * 7
      );
    },
    // 添加图片
    changeFile(file, fileList) { },
    submitClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        let days = (Date.parse(this.formData.endTime) - Date.parse(this.formData.startTime)) / 86400000;
        if (days > 7) {
          this.$message.warning("时间周期不能大于1周!");
          return false;
        } else if (days <= 0) {
          this.$message.warning("结束时间必须大于开始时间!");
          return false;
        }
        this.searchPerson();
      });
    },
    searchPerson() {
      this.searchTrackDetails();
    },
    searchTrackDetails() {
      let self = this;
      let params = {
        carNumber: this.formData.carNumber,
        startTime: this.getDate(this.formData.startTime),
        endTime: this.getDate(this.formData.endTime),
      };
      this.searchBtn = true;
      this.$fetch(api.queryCarPoints, params).then((res) => {
        self.searchBtn = false;
        self.clearTrack();
        if (res.success) {
          if (!res.returnObj || !res.returnObj.length) {
            this.$message.warning("暂无轨迹信息");
            return;
          }
          this.main = false;
          this.personDataList = res.returnObj;
          if (this.personDataList.length > 0) {
            this.$nextTick(() => {
              this.getTrajectory(res.returnObj[0].records, 0);
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    getTrajectory(item, value) {
      this.selectedFlag = value;
      this.clearTrack();
      this.queryTrackPoints(item)
    },
    queryTrackPoints(item) {
      this.trackPoints = []
      let pointsArr = []
      for (let i = 0; i < item.length; i++) {
        pointsArr.push({
          "point": [Number(item[i].longitude), Number(item[i].latitude)]
        })
      }
      let params = {
        "parkName": "lunanzhiyao",
        "navigationDataInfoList": pointsArr,
        "isInDoor": false
      }
      this.$fetch("/com.cloud.isoft.graphhopperreadershp.service/getNavigationRoutesForWalk", params).then((res) => {
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            if (res[i].points.length > 0) {
              for (let j = 0; j < res[i].points.length; j++) {
                this.trackPoints.push(
                  {
                    data: {
                      longitude: res[i].points[j][0],
                      latitude: res[i].points[j][1]
                    }
                  }
                )
              }
            }
          }
          this.trackPoints.shift()
          this.trackPoints.pop()
          this.handleShowDrawLine()
        } else {
          this.$message.error("轨迹查询失败");
        }
      });
    },
    handleShowDrawLine() {
      let pointCoord = []; //坐标集合
      let circleInfo = []; //标记集合
      let list = this.trackPoints
      list.forEach((val, index) => {
        pointCoord.push([+val.data.longitude || +val.data.lng, +val.data.latitude || +val.data.lat]);
        circleInfo.push({
          longitude: +val.data.longitude || +val.data.lng,
          latitude: +val.data.latitude || +val.data.lat,
          radius: 15, //半径
          label: index == 0 ? "起" : index == list.length - 1 ? "终" : String(index + 1),
          outline: false, //是否显示轮廓线
          outlineWidth: 3,
          height: 10, //高度
          outlineColor: "#3E76E6", //轮廓线颜色
          fill: true, //是否填充颜色
          labFillColor: "#000000",
          fillColor: index == 0 ? "rgba(112,181,4,1)" : index == list.length - 1 ? "rgba(217,0,27,1)" : "#3E76E6", //颜色
          attr: { ...val.data, child: val.child },
        });
      });
      //绘制轨迹信息并地图居中显示
      this.$map.MapInstance2D.positionByPoint(pointCoord && pointCoord[0]);
      this.$map.MapInstance2D.drawTrajectory(
        this.constLayerId.line,
        [
          {
            coord: pointCoord,
            id: "alarmTrackId",
            attr: list,
          },
        ],
        {
          isDirect: true,
        }
      );
      this.$map.MapInstance2D.addCircles(circleInfo, this.constLayerId.circles);
    },
    resetFrom() {
      this.formData.startTime = Dates.parse(
        Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7)
      );
      this.formData.endTime = Dates.parse(Dates.format(new Date()));
      this.formData.carNumber = "";
      this.$refs["ruleForm"].resetFields();
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.returnObj[0].fileId;
      this.fileId = res.returnObj[0].fileId;
    },
    handleVisible() {
      this.visibleRight = !this.visibleRight;
    },
    back() {
      this.main = true;
      this.clearTrack();
    }
  }
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.car-mg_person_research {
  .upload-img-item {
    display: inline-block;
    width: 100%;
    padding: 10px 0;

    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }

    .el-upload,
    .img-card,
    .img {
      width: 130px;
      height: 115px;
      line-height: 115px;
      // background-color: #0d121c;
    }

    .delete-icon {
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 10px;
      left: 0px;
      width: 130px;
      height: 115px;
      // border-radius: 6px;
      opacity: 0;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.4);
      transition: all 0.2s;
      box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
    }

    .el-icon-delete {
      color: #fff;
    }
  }

  .search-item {
    .el-input__inner {
      padding-right: 32px;
    }

    img {
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  margin: 0;

  .list-content {
    .right-name {
      .el-form-item__content {
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .el-scrollbar__view {
    height: 100%;
  }

  .section-content {
    position: relative;
    // padding: 10px 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .search-result {
    flex: 1;
    margin-top: 20px;
    min-height: 240px;
  }

  .result-data-list {
    // overflow: hidden;
    margin-right: 5px;
    overflow-y: auto;
  }

  .searchList {
    // cursor: pointer;
    border-radius: 5px;
    display: flex;
    padding: 10px;
    @include set_theme_color(background-color, item-active-bg-color);
    width: 95%;
    margin: 10px 15px;

    &:hover {
      opacity: 0.7;
    }
  }

  .track {
    height: calc(100% - 200px);

    &__list {
      display: flex;
      flex-flow: row wrap;
      padding: 10px;
      border-radius: 5px;
      // margin: 10px 0px;
      position: relative;
      cursor: pointer;
      // @extend .bg-color;
      @include set_theme_color(background-color, map-panel-content);
      font-size: 12px;
      margin-bottom: 12px;

      &__time {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      &__detail {
        display: flex;
        margin: 5px 5px;
        width: 30%;

        &.expand {
          height: 100%;
        }

        &.collspand {
          display: none;
        }

        .detail-img {
          position: relative;
          height: 0; // 设置高为0，让padding撑起高
          padding-bottom: 90%;
          margin-bottom: 10px;

          &__img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }

          &--check {
            position: absolute;
            top: 5px;
            right: 5px;
          }
        }
      }

      &__btn {
        width: 100%;
        text-align: center;
      }

      &--expand {
        height: 100%;
        margin-bottom: 10px;
      }

      &--collspand {
        display: none;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    &--checked {
      @include set_theme_color(border-color, main-theme-color);
      border: 1px solid;
    }
  }
}

.vehicle-to {
  position: absolute;
  right: 0;
  z-index: 2;
  width: 350px;
  box-sizing: border-box;
  height: 100%;
  @include set_animation(right);

  &.expand {
    right: 0;
  }

  &.collspand {
    right: -350px;
  }
}

.more-list {
  width: 100%;
  text-align: center;

  &.expand {
    height: 100%;
  }

  &.collspand {
    display: none;
  }
}

.car-mg_person_research .el-dialog {
  width: 25%;
}

.title {
  border-left: 4px solid #407aee;
  padding-left: 10px;
  margin: 20px 12px 12px;
}

.search-title {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  // color: #fff;
  flex: 0 0 auto;
  background: #fff !important;
}

.search-content {
  margin: 12px;
}

.search-bg {
  padding: 12px;
  @include set_theme_color(background-color, map-panel-content);
}

.search-form {
  overflow: hidden;
  width: 100%;
}

.car-track-search .track-box {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  background-color: #E4E7ED;
  padding-left: 15px;
  margin: 10px 0;
  cursor: pointer;
}

.car-track-search .track-box:hover {
  background-color: #b3d8ff !important;
}

.selected-track-box {
  background-color: #b3d8ff !important;
}
</style>

